import { BOTTONSHEET_KEYS } from '@root/constants';

type InfoModal = {
  visible: boolean;
  data: any;
  errorCode: string;
};

type BankRow = {
  id: string | number;
  [key: string]: any;
};

type BeneficiaryDeleteMutate = (id: string | number) => void;

export default function bankListBottomSheetHandlers(
  infoModal: InfoModal,
  setInfoModal: any,
  beneficiaryDeleteMutate: BeneficiaryDeleteMutate,
) {
  const onPressPrimaryBottomSHeet = (bankRowPressed: BankRow) => {
    if (infoModal.errorCode === BOTTONSHEET_KEYS.BANK_DELETE) {
      setInfoModal({ ...infoModal, visible: false });
      beneficiaryDeleteMutate(bankRowPressed.id);
    } else {
      setInfoModal({ ...infoModal, visible: false });
    }
  };

  const onPressSecondaryBottomSheet = () => {
    setInfoModal({ ...infoModal, visible: false });
  };

  const onCloseModalHandler = () => {
    setInfoModal({ ...infoModal, visible: false });
  };

  return {
    onPressPrimaryBottomSHeet,
    onPressSecondaryBottomSheet,
    onCloseModalHandler,
  };
}
